(() => {
  const init = () => {
    const tabs = [...document.querySelectorAll('[data-ct-shop-tab]')];
    const panels = [...document.querySelectorAll('[data-ct-shop-panel]')];
    if (!tabs.length || !panels.length) return;
    const activate = (name) => {
      tabs.forEach(t => { const on=t.dataset.ctShopTab===name; t.classList.toggle('is-active',on); t.setAttribute('aria-selected',on?'true':'false'); });
      panels.forEach(p => { const on=p.dataset.ctShopPanel===name; p.classList.toggle('is-active',on); p.hidden=!on; });
    };
    tabs.forEach(t => t.addEventListener('click', () => activate(t.dataset.ctShopTab)));
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
